import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-quote-document-dialog',
  standalone: true,
  imports: [MatButtonModule, MatDialogModule],
  templateUrl: './quote-document-dialog.component.html',
  styleUrl: './quote-document-dialog.component.scss'
})
export class QuoteDocumentDialogComponent {
  constructor(private dialogRef: MatDialogRef<QuoteDocumentDialogComponent>) {}

  onDownload() {
    this.dialogRef.close('download'); 
  }

  onEmail() {
    this.dialogRef.close('email');
  }

  onCancel() {
    this.dialogRef.close('cancel');
  }
}

